<template>
  <div class="py-6 px-6">
    <div class="mb-6">
      <h2 class="text-2xl font-bold text-typo">下載 App</h2>
    </div>

    <v-row>
      <!-- Android Section -->
      <v-col cols="12" md="6">
        <v-card
          class="card-shadow border-radius-xl p-6 h-100 flex-column d-flex"
        >
          <div class="d-flex align-center">
            <div class="qr-container mr-6">
              <a
                href="https://play.google.com/store/apps/details?id=com.hansome.hr"
                target="_blank"
                rel="noopener"
              >
                <v-img
                  alt="Android 下載 QR"
                  :src="require('@/assets/img/google-playstore.png')"
                  width="250"
                  height="250"
                  contain
                  class="border-radius-lg border"
                />
              </a>
            </div>
            <div>
              <h3 class="text-xl font-semibold text-typo mb-2">Android 版</h3>
              <p class="text-body text-gray-600 mb-4">
                Google Play 下載, 搜尋 <strong>PAKA</strong>
              </p>
              <v-btn
                href="https://play.google.com/store/apps/details?id=com.hansome.hr"
                target="_blank"
                rel="noopener"
                color="primary"
                class="
                  text-white
                  px-6
                  py-2
                  font-medium
                  elevation-0
                  border-radius-lg
                  btn-primary
                  bg-gradient-primary
                "
              >
                <v-icon left size="18">mdi-google-play</v-icon>
                前往下載
              </v-btn>
            </div>
          </div>
        </v-card>
      </v-col>

      <!-- iOS Section -->
      <v-col cols="12" md="6">
        <v-card
          class="card-shadow border-radius-xl p-6 h-100 d-flex flex-column"
        >
          <div class="d-flex align-center">
            <div class="qr-container mr-6">
              <a
                href="https://apps.apple.com/tw/app/paka/id6754371335"
                target="_blank"
                rel="noopener"
              >
                <v-img
                  alt="iOS 下載 QR"
                  :src="require('@/assets/img/ios-qr.png')"
                  width="250"
                  height="250"
                  contain
                  class="border-radius-lg border"
                />
              </a>
            </div>
            <div>
              <h3 class="text-xl font-semibold text-typo mb-2">iOS 版</h3>
              <p class="text-body text-gray-600 mb-4">
                App Store 下載, 搜尋 <strong>PAKA</strong>
              </p>
              <v-btn
                href="https://apps.apple.com/tw/app/paka/id6754371335"
                target="_blank"
                rel="noopener"
                color="info"
                class="
                  text-white
                  px-6
                  py-2
                  font-medium
                  elevation-0
                  border-radius-lg
                  btn-primary
                  bg-gradient-primary
                "
              >
                <v-icon left size="18">mdi-apple</v-icon>
                前往下載
              </v-btn>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "app-download",
};
</script>

<style scoped>
.qr-container {
  background: #fff;
  padding: 4px;
  border-radius: 12px;
}
.border {
  border: 1px solid #eceef1 !important;
}
.text-typo {
  color: #344767 !important;
}
</style>
